<div class="container mt-5 pt-5">
    <div class="row justify-content-center align-items-center">
        <div class="col-8">
            <form [formGroup]="meetingForm">
                <div class="form-group mt-1">
                  <label for="meetingid">Meeting ID</label>
                  <input formControlName="meetingId" type="email" class="form-control mt-1" [ngClass]="{ 'is-invalid': isFormSubmitted && a['meetingId'].errors }" id="meetingid" >
                  <div *ngIf="a['meetingId'].errors && isFormSubmitted">
                    <div *ngIf="a['meetingId'].errors['required']" class="text-danger letterspacing">
                        Meeting ID is required
                    </div>
                  </div>
                </div>
                <div class="form-group mt-1">
                  <label for="token">Token</label>
                  <textarea formControlName="token" class="form-control mt-1" [ngClass]="{ 'is-invalid': isFormSubmitted && a['token'].errors }" id="token" rows="3"></textarea>
                  <div *ngIf="a['meetingId'].errors && isFormSubmitted">
                    <div *ngIf="a['meetingId'].errors['required']" class="text-danger letterspacing">
                        Token is required
                    </div>
                  </div>
                </div>
                <div class="form-group mt-1">
                    <button type="submit" class="btn btnc mt-1" (click)="submitForm()" >Submit</button>
                </div>  
              </form>
        </div>
    </div>
</div>